/* DON'T EDIT THIS FILE: edit original and run build again */ import { WarningCircleIcon } from "../../framework/theme-icons/icon.ts";
import { Div } from "../../onboarding/pdf-wrapper/pdf-wrapper.tsx";
import React from "react";

export const ErrorMessage = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <Div className={"color-danger " + className}>
      <WarningCircleIcon className="mb-1 me-2" />
      {children}
    </Div>
  );
};

export const WarningMessage = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <Div className={"" + className}>
      <WarningCircleIcon className="color-warning icon-1 mb-1 me-2" />
      {children}
    </Div>
  );
};
